<template>
  <v-form v-model="isValidEvaluationForm">
    <v-row>
      <v-col>
        <v-autocomplete
          class="ui-form-field"
          v-model="evaluation.idPersonalEvaluador"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          :items="getPersonalLite"
          item-value="idPersonal"
          :item-text="getFullName"
          item-color="secondary"
          :rules="required"
          :loading="loadingPersonalLite"
          :filter="filterPersonal"
        >
          <template v-slot:label>Personal evaluador <span class="red--text">*</span> </template>
          <template v-slot:item="data">
            <v-list-item-avatar>
              <v-icon>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ getFullName(data.item) }}</v-list-item-title>
              <v-list-item-subtitle>{{ data.item.CUIP }} · {{ data.item.puesto }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          class="ui-form-field"
          v-model="evaluation.idMunicipio"
          rounded
          filled
          dense
          background-color="transparent"
          color="secondary"
          :items="municipios"
          item-value="id"
          item-text="nombre"
          item-color="secondary"
          :rules="required"
        >
          <template v-slot:label>Municipio <span class="red--text">*</span> </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.nombre }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.catEstado.title }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col>
        <v-menu
          v-model="isActiveMenuFechaInicioAcademico"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="ui-form-field"
              :value="fechaInicioFormatted"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              :rules="required"
            >
              <template v-slot:label>Fecha inicio <span class="red--text">*</span> </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="evaluation.fechaInicio"
            @input="isActiveMenuFechaInicioAcademico = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          v-model="menuFechaFinAcademico"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="ui-form-field"
              :value="fechaFinFormatted"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              :rules="required"
            >
              <template v-slot:label>Fecha de conclusión <span class="red--text">*</span> </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="evaluation.fechaFin"
            @input="menuFechaFinAcademico = false"
            :min="fechaInicioPermitida"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          v-model="menuFechaAplicacionAcademico"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="ui-form-field"
              :value="fechaAplicacionFormatted"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              rounded
              filled
              dense
              color="secondary"
              background-color="transparent"
              :rules="required"
            >
              <template v-slot:label
                >Fecha de aplicación
                <span class="red--text">*</span>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="evaluation.fechaAplicacion"
            :min="fechaFinalPermitida"
            @input="menuFechaAplicacionAcademico = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          class="ui-form-field"
          v-model="evaluation.institucionSeguridadAspirada"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          :rules="required"
        >
          <template v-slot:label
            >Institución de seguridad pública a la que aplica
            <span class="red--text">*</span>
          </template>
        </v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          class="ui-form-field"
          label="Aspirante al puesto de"
          v-model="evaluation.puestoAspirado"
          rounded
          filled
          dense
          color="secondary"
          background-color="transparent"
          :rules="required"
        >
          <template v-slot:label>Aspirante al puesto de <span class="red--text">*</span> </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" align="center">
        <v-btn
          class="ui-module-btn-solid"
          @click="initializeAcademicPerformanceEvaluations()"
          :loading="loading"
          :disabled="loading || !isValidEvaluationForm"
          >Guardar información</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { HUMAN_READABLE_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '../../../../const'
import DateAdapter from '../../../../utils/DateAdapter'
import { ACADEMIC_PERFORMANCE_EVALUATION_TYPES } from '../../../../modules/evaluacion-desempeño-academico/domain/entities/Evaluation'
import CreateRespetoValoresPrincipios from '@/modules/respeto-valores-principios/application/CreateRespetoValoresPrincipios.usecase'
import RespetoValoresPrincipiosApiRepository from '@/modules/respeto-valores-principios/infrastructure/RespetoValoresPrincipiosApi.repository'
import CreateRendimientoProfesionalismo from '@/modules/rendimiento-profesionalismo/application/CreateRendimientoProfesionalismo.usecase'
import RendimientoProfesionalismoApiRepository from '@/modules/rendimiento-profesionalismo/infrastructure/RendimientoProfesionalismoApi.repository'
import CreateDesempeñoInstitucional from '@/modules/desempeño-institucional/application/CreateDesempeñoInstitucional.usecase'
import DesempeñoInstitucionalApiRepository from '@/modules/desempeño-institucional/infrastructure/DesempeñoInstitucionalApi.repository'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'

export default {
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },

    evaluation: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      loadingPersonalLite: false,
      isValidEvaluationForm: false,
      isActiveMenuFechaInicioAcademico: false,
      menuFechaFinAcademico: false,
      menuFechaAplicacionAcademico: false,
      required: [(v) => !!v || 'Este campo es requerido'],
    }
  },

  watch: {
    evaluation: {
      handler(newValue) {
        if (newValue.fechaInicio) {
          this.setFechaFin()
        }
      },

      deep: true,
    },
  },

  computed: {
    ...mapGetters('personal', { getPersonalLite: 'getPersonalLite' }),
    ...mapGetters('municipio', { municipios: 'getMunicipios' }),
    ...mapGetters('personal', { personalEvaluado: 'getPersonalSingle' }),

    fechaInicioFormatted() {
      return this.evaluation.fechaInicio
        ? new DateAdapter(this.evaluation.fechaInicio, VUETIFY_DATE_FORMAT).toHumanReadable()
        : ''
    },

    fechaFinFormatted() {
      return this.evaluation.fechaFin
        ? new DateAdapter(this.evaluation.fechaFin, VUETIFY_DATE_FORMAT).toHumanReadable()
        : ''
    },

    fechaAplicacionFormatted() {
      return this.evaluation.fechaAplicacion
        ? new DateAdapter(this.evaluation.fechaAplicacion, VUETIFY_DATE_FORMAT).toHumanReadable()
        : ''
    },

    fechaInicioPermitida() {
      return this.fechaInicioFormatted != ''
        ? new DateAdapter(this.fechaInicioFormatted, HUMAN_READABLE_DATE_FORMAT).toUiSupportedFormat()
        : ''
    },

    fechaFinalPermitida() {
      return this.evaluation.fechaFin
        ? moment(this.evaluation.fechaFin, VUETIFY_DATE_FORMAT).add(1, 'day').format(VUETIFY_DATE_FORMAT)
        : ''
    },
  },

  async mounted() {
    this.loadingPersonalLite = true
    try {
      await this.fetchPersonalLite()
    } catch (error) {
      console.error(error)
    } finally {
      this.loadingPersonalLite = false
    }
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalLite']),
    ...mapActions('notificaciones', ['createNotification']),
    async sendNotificacion() {
      const evaluado = this.personalEvaluado || {}
      const nombreEvaluado = this.getFullName(evaluado) || 'Sin evaluado'
      const cuipEvaluado = evaluado.CUIP || 'Sin CUIP'

      const nombreEvaluador = [
        localStorage.getItem('nombre'),
        localStorage.getItem('segundoNombre'),
        localStorage.getItem('apaterno'),
        localStorage.getItem('amaterno'),
      ]
        .filter(Boolean)
        .join(' ')

      const mensaje = `El personal ${nombreEvaluador} ha registrado un proceso de evaluación de desempeño al elemento ${nombreEvaluado} con CUIP: ${cuipEvaluado}.`

      const notification = new NotificationFactory(Notificacion).createNotification(
        NOTIFICATION_TYPES.CAMBIO_EVALUACION_DESEMPENO_ACADEMICO,
        {
          responsable: Number(localStorage.getItem('idPersonal')),
          afectado: Number(this.idPersonal),
          mensaje,
        }
      )

      await this.createNotification(notification)
    },

    getFullName(persona) {
      if (!persona) return ''
      return [persona.nombre, persona.segundoNombre, persona.apaterno, persona.amaterno].filter(Boolean).join(' ')
    },

    filterPersonal(item, queryText) {
      const q = queryText.toLowerCase()
      const nombre = this.getFullName(item).toLowerCase()
      const cuip = (item.CUIP || '').toLowerCase()
      const puesto = (item.puesto || '').toLowerCase()
      return nombre.includes(q) || cuip.includes(q) || puesto.includes(q)
    },

    async initializeAcademicPerformanceEvaluations() {
      this.loading = true

      try {
        const createRespectForValuesAndPrinciplesPromise = new CreateRespetoValoresPrincipios(
          new RespetoValoresPrincipiosApiRepository()
        ).execute(this.evaluation, this.idPersonal)

        const createPerformanceAndProffesionalismPromise = new CreateRendimientoProfesionalismo(
          new RendimientoProfesionalismoApiRepository()
        ).execute(this.evaluation, this.idPersonal)

        const createInstitutionalPerformancePromise = new CreateDesempeñoInstitucional(
          new DesempeñoInstitucionalApiRepository()
        ).execute(this.evaluation, this.idPersonal)

        const [
          respectForValuesAndPrinciplesEvaluationId,
          performanceAndProfessionalismEvaluationId,
          institutionalPerformanceEvaluationId,
        ] = await Promise.all([
          createRespectForValuesAndPrinciplesPromise,
          createPerformanceAndProffesionalismPromise,
          createInstitutionalPerformancePromise,
        ])
        await this.sendNotificacion()

        this.$emit('save', {
          respectForValuesAndPrinciplesEvaluationId,
          performanceAndProfessionalismEvaluationId,
          institutionalPerformanceEvaluationId,
        })
      } catch (error) {
        console.error('Error initializing evaluations:', error)
      }

      this.loading = false
    },

    setFechaFin() {
      if (
        moment(this.evaluation.fechaInicio, VUETIFY_DATE_FORMAT).isAfter(
          moment(this.evaluation.fechaFin, VUETIFY_DATE_FORMAT)
        )
      ) {
        this.evaluation.fechaFin = ''
      }
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-field .mdi-menu-down,
::v-deep .ui-form-field .mdi-calendar {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: var(--v-secondary-base) !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

.ui-module-btn-solid {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #08130f !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.28) !important;
  transition: all 0.3s ease;
}

.ui-module-btn-solid:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}
</style>
